<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card styleClass="very-compact-card p-3">
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">Название</label>
        <crm-input-text
          [(value)]="adapter.name"
          [isError]="$any(errors?.name)"></crm-input-text>
        <small
          *ngIf="errors?.name"
          class="p-error">
          {{ errors.name | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Тип</label>
        <p-selectButton
          [options]="adapterTypeOptions"
          [(ngModel)]="adapter.type"
          optionLabel="label"
          optionValue="value"></p-selectButton>
        <small
          *ngIf="errors?.type"
          class="p-error">
          {{ errors.type | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium">MAC-адрес</label>
        <crm-input-text
          [(value)]="adapter.mac"
          [isError]="$any(errors?.mac)"></crm-input-text>
        <small
          *ngIf="errors?.mac"
          class="p-error">
          {{ errors.mac | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium">IP-адрес</label>
        <crm-input-text
          [(value)]="adapter.ipAddress"
          [isError]="$any(errors?.ipAddress)"></crm-input-text>
        <small
          *ngIf="errors?.ipAddress"
          class="p-error">
          {{ errors.ipAddress | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium">Помещение</label>
        <crm-room-single-select
          [(selectedRoom)]="adapter.room"
          [isError]="$any(errors?.room)"
          appendTo="body"></crm-room-single-select>
        <small
          *ngIf="errors?.room"
          class="p-error">
          {{ errors.room | join }}
        </small>
      </div>
    </div>
  </p-card>

  <p-card styleClass="mt-3 very-compact-card p-3">
    <h3 class="mb-0">Сенсоры</h3>

    <crm-table
      *ngIf="adapter.sensors?.length"
      [columns]="sensorColumns"
      [values]="adapter.sensors || []"
      styleClass="p-datatable-sm mt-2">
      <ng-template
        #rowTemplate
        let-sensor="item">
        <tr *ngIf="toSensor(sensor) as sensor">
          <td>
            <crm-input-text
              [(value)]="sensor.name"
              class="w-full"></crm-input-text>
          </td>
          <td>
            <p-selectButton
              [options]="sensorTypeOptions"
              [(ngModel)]="sensor.type"
              optionLabel="label"
              optionValue="value"></p-selectButton>
          </td>
          <td>
            <i
              class="pi pi-times text-red-500 hover:text-red-300 cursor-pointer"
              style="font-size: 1.3rem"
              (click)="deleteSensor(sensor)"></i>
          </td>
        </tr>
      </ng-template>
    </crm-table>

    <button
      pButton
      label="Добавить"
      icon="pi pi-plus"
      class="p-button-success p-button-text mt-2"
      (click)="addSensor()"></button>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveAdapter()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteAdapter()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
